const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/inbox/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import i18n from '@/common/translations/i18n';
const paramSchema = z.object({
  formId: z.number().optional(),
  removeImport: z.boolean().optional(),
  feedbackId: z.number().optional(),
  productAreaIds: z.array(z.number()).optional()
});
export const Route = createFileRoute('/(app)/org/$org/intake/inbox/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: paramSchema,
  staticData: {
    topNav: {
      title: i18n.t($ => $.intake.general.feedbackInbox.label)
    }
  }
});